import { FC, memo, ReactNode, SVGProps } from 'react';

import useClientState from '@/state/useClientState';

import { preventDefault } from '../../utils/mwdEvents/eventHelpers';

type MwdSvgProps = SVGProps<SVGSVGElement> & {
  children: ReactNode | ReactNode[];
  mwdHeight: number;
  mwdWidth: number;
};

const MwdSvg: FC<MwdSvgProps> = ({ children, mwdHeight, mwdWidth, ...svgProps }) => {
  const viewBox = `0 0 ${mwdWidth} ${mwdHeight}`;
  const deselectAll = useClientState((state) => state.deselectAll);
  return (
    <svg
      version='2'
      data-testid='mwdSvg'
      id='mwdSvg'
      viewBox={viewBox}
      width={mwdWidth}
      height={mwdHeight}
      {...svgProps}
      onClick={(event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        const clickedTarget = event.target as SVGGElement | SVGRectElement;
        if (event.currentTarget.id === clickedTarget?.getAttribute('id') && event.currentTarget.id === 'mwdSvg') {
          // Deselect all
          void deselectAll();
        }
      }}
      onContextMenu={(event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        const clickedTarget = event.target as SVGGElement | SVGRectElement;
        if (event.currentTarget.id === clickedTarget?.getAttribute('id') && event.currentTarget.id === 'mwdSvg') {
          // Deselect all
          void deselectAll();
        }
        return preventDefault(event);
      }}
    >
      <defs>
        <pattern
          id='arceringPattern'
          patternUnits='userSpaceOnUse'
          width={20}
          height={49}
          patternTransform='rotate(30)'
        >
          <line
            y2={49}
            stroke='var(--mwd-color-treintaak-background-defect-niet-inzetbaar)'
            strokeOpacity={0.15}
            strokeWidth={20}
          />
        </pattern>
      </defs>
      {children}
    </svg>
  );
};
export default memo(MwdSvg);
